import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Container, VStack, Select, HStack } from "@chakra-ui/react";
import { Input, message, Pagination, Button } from "antd";
import RoundScoresTable from "../components/RoundscoresTable";
import Cookies from "js-cookie";
import { firebaseAPI } from "../firebaseConfig";
import { BeatLoader } from "react-spinners";
import { css } from "@emotion/react";
import axiosInstance from "../utils/axiosInstance";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

const RoundscoresPage = () => {
  const { formName, programName } = useParams();
  const [roundscores] = useState(new Map());
  const [filter, setFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [jumpToPage, setJumpToPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [scoreSortCriteria, setScoreSortCriteria] = useState("");

  useEffect(() => {
    // fetchRoundscores();
    // if (scoreSortCriteria !== "") {
    //   fetchRoundscoresSorted(scoreSortCriteria);
    // } else if (filter !== "" || statusFilter !== "") {
    //   fetchRoundscoresWithSearch(filter, statusFilter, scoreSortCriteria);
    // } else {
    //   fetchRoundscores();
    // }
  }, [page]);

  // useEffect(() => {
  //   fetchRoundscores();
  // }, []);

  const fetchAndDownloadParticipantsCSV = async () => {
    try {
      let token = Cookies.get("token") || "";
      const response = await axiosInstance.get(
        `${firebaseAPI}/users/participants`,
        {
          headers: {
            // A temporary way to manually use token until implement the sign-in feature
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const participants = response.data; // Assuming response.data is the array of participants}

      // Step 2: Convert data to CSV format
      const csvContent = participants
        .map((participant) => Object.values(participant).join(","))
        .join("\n");
      const csvBlob = new Blob([csvContent], { type: "text/csv" });

      // Step 3: Trigger file download
      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(csvBlob);
      downloadLink.download = "participants.csv";
      downloadLink.click();
    } catch (error) {
      console.error("Error fetching or downloading participants:", error);
    }
  };

  const fetchRoundscores = async () => {
    setLoading(true);

    try {
      const token = Cookies.get("token") || "";

      if (!token) {
        throw new Error("Authentication token not found.");
      }

      const response = await axiosInstance.get(
        `${firebaseAPI}/forms/${formName}/${programName}/submissions`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: { page, limit: 20 },
        }
      );

      let submissions = response.data?.submissions ?? [];
      const totalPages = response.data?.totalPages ?? 0;

      roundscores.clear();
      submissions = submissions.map((submission) => {
        return {
          ...submission,
          submissionId:
            submission.submissionId ||
            `placeholder-${Math.floor(Math.random() * 1e9)}`,
        };
      });

      submissions.forEach((submission) => {
        const key = submission.submissionId;

        if (key) {
          roundscores.set(key, {
            ...submission,
            judgeScore: submission.judgeScore || 0,
            judgesAndScores: submission.judgesAndScores || [],
            submissionId: submission.submissionId || null,
          });
        }
      });
      setTotalPages(totalPages);
    } catch (error) {
      const serverMessage = error?.response?.data?.message || error.message;
      message.error(serverMessage || "No submissions found");
    } finally {
      setLoading(false);
    }
  };

  const fetchRoundscoresSorted = async (sort) => {
    try {
      setLoading(true);
      let token = Cookies.get("token") || "";
      const response = await axiosInstance.get(
        `${firebaseAPI}/forms/${formName}/${programName}/submissions/sortedScores`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: { page, limit: 20, sort },
        }
      );

      roundscores.clear();

      response.data.submissions.map((submission) => {
        roundscores.set(submission.submissionId, submission);
      });

      // setRoundscores(response.data.submissions);
      setTotalPages(response.data.totalPages);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      message.error("No submissions found");
      console.error("Error fetching roundscores:", error);
    }
  };

  const fetchRoundscoresWithSearch = async (
    searchTerm,
    filter_status,
    scoreSortCriteria,
    sort
  ) => {
    try {
      setLoading(true);
      //setPage(1);
      let token = Cookies.get("token") || "";
      const response = await axiosInstance.get(
        `${firebaseAPI}/forms/${formName}/${programName}/submissions/search`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            page,
            limit: 20,
            searchTerm,
            statusFilter: filter_status,
            sort,
          },
        }
      );

      roundscores.clear();

      response.data.submissions.map((submission) => {
        roundscores.set(submission.submissionId, submission);
      });

      // setRoundscores(response.data.submissions);
      setTotalPages(response.data.totalPages);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      message.error("No submissions found");
      console.error("Error fetching roundscores:", error);
    }
  };

  const handlePageChange = (newPage) => {
    ////console.log(newPage);
    setPage(newPage);
  };

  const handleFilterChange = (event) => {
    setScoreSortCriteria("");
    setFilter(event.target.value);
    if (event.target.value === "") {
      setPage(1);
      fetchRoundscores();
    }
  };

  const handleSearchButton = () => {
    setScoreSortCriteria("");
    if (filter !== "") {
      setPage(1);
      fetchRoundscoresWithSearch(filter, statusFilter, scoreSortCriteria);
    } else {
      fetchRoundscores();
    }
  };

  const handleStatusFilterChange = (event) => {
    setScoreSortCriteria("");
    setStatusFilter(event.target.value);
    if (event.target.value !== "") {
      fetchRoundscoresWithSearch(filter, event.target.value, scoreSortCriteria);
    } else {
      fetchRoundscores();
    }
  };

  const handleScoreSortFilterChange = (event) => {
    setScoreSortCriteria(event.target.value);
    setStatusFilter("");
    setFilter("");
    setPage(1);
    fetchRoundscoresSorted(event.target.value);
    // fetchRoundscoresWithSearch(filter, statusFilter, event.target.value);
  };

  // const filteredRoundscores = roundscores.values().filter((roundscore) => {
  //   const submissionTitle = roundscore.user.name
  //     ? roundscore.user.name.toLowerCase()
  //     : ""; // Change here
  //   const judgeName = roundscore.judge
  //     ? roundscore.judge.name
  //       ? roundscore.judge.name.toLowerCase()
  //       : ""
  //     : ""; // Change here

  //   // if (filter) {
  //   //   return (
  //   //     submissionTitle.includes(filter.toLowerCase()) ||
  //   //     judgeName.includes(filter.toLowerCase())
  //   //   );
  //   // }

  //   if (statusFilter && roundscore.status !== statusFilter) {
  //     return false;
  //   }
  //   return true;
  // });

  // const filteredRoundscores = new Map(
  //   [...roundscores].filter(([submissionId, roundscore]) => {
  //     const submissionTitle = roundscore.user.name
  //       ? roundscore.user.name.toLowerCase()
  //       : ""; // Change here
  //     const judgeName = roundscore.judge
  //       ? roundscore.judge.name
  //         ? roundscore.judge.name.toLowerCase()
  //         : ""
  //       : ""; // Change here

  //     if (filter) {
  //       return (
  //         submissionTitle.includes(filter.toLowerCase()) ||
  //         judgeName.includes(filter.toLowerCase())
  //       );
  //     }

  //     if (statusFilter && roundscore.status !== statusFilter) {
  //       return false;
  //     }
  //     return true;
  //   })
  // );

  return (
    <Container maxW="container.lg" mt="6">
      {loading && (
        <BeatLoader
          color="#123abc"
          loading={loading}
          css={override}
          size={15}
        />
      )}
      {!loading && (
        <div>
          {/* <VStack spacing="4" mb="4">
            <Input
              placeholder="Search by Submission Title or Judge Name"
              value={filter}
              onChange={handleFilterChange}
              size="lg"
              style={{ width: "50%" }}
            />
            <Button type="primary" onClick={handleSearchButton}>
              Search
            </Button>
          </VStack> */}
          <div>
            <RoundScoresTable
              roundscores={roundscores}
              formName={formName}
              programName={programName}
              fetchRoundscores={fetchRoundscores}
            />
          </div>
        </div>
      )}
    </Container>
  );
};

export default RoundscoresPage;
